<shared-generalstatus-container class="card" [ngClass]="getGeneralClass()" *ngIf="route"
    [generalStatus]="route.generalStatus" (dragstart)="onDragStart($event)" (dragenter)="onDragEnter($event)"
    (dragleave)="onDragLeave($event)" [draggable]="isDraggable">
    <div class="internalcard"
        [ngClass]="{'isSlotBlocked':route.isSlotBlocked, 'incompatibleSlot':route.incompatibleSlot}">
        <div class="leftData">
            <!-- TÍTOL -->
            <div class="line route-title ellipsis">
                {{route.title}}
                <span class="route-titlesubtitle">{{route.titleSubtitle}}</span>
            </div>

            <!-- SUBTÍTOL -->
            <div class="line route-subtitle ellipsis">{{route.subtitle}}
            </div>

            <!-- DATES -->
            <div class="line route-description ellipsis no-mini" *ngIf="route.line1">{{ route.line1 }}
            </div>
            <div class="line route-description ellipsis disp no-mini" *ngIf="route.line2">{{ route.line2 }}
            </div>
            <div class="line route-description ellipsis no-mini" *ngIf="route.line3">{{ route.line3 }}
            </div>

            <!-- RETAÏLA D'ETIQUETES -->
            <shared-tags-strip-component class="only-single no-mini no-reduced"
                [tags]="allTags"></shared-tags-strip-component>
            <shared-tags-strip-component class="only-llista no-mini no-reduced" [maxTags]="MAX_TAGS_IN_LIST_ITEM"
                [tags]="allTags"></shared-tags-strip-component>

            <!-- MISSATGES PENDENTS -->
            <div *ngIf="isActiveRoutes && route.pendingMessagesRead > 0" class="pending-messages no-mini">
                <i class="fa fa-commenting icon" aria-hidden="true"></i>
                <div class="number">{{ route.pendingMessagesRead }}</div>
            </div>
        </div>

        <div class="bottom-zone">
            <shared-route-strip-component [route]="route"
                [isActiveRoutes]="isActiveRoutes"></shared-route-strip-component>
        </div>

        <!-- SEMÀFOR -->
        <span *ngIf="route.showMMResponseStatus && route.responseStatus != null" class="responseStatusContainer no-mini"
            [ngClass]="{'withdock' : route.docks != null && route.docks.length > 0 }">
            <div class="responseStatus" [ngClass]="route.responseStatus"></div>
        </span>

        <!-- FILLES -->
        <div *ngIf="route.isDivided" class="showchilds ichilds no-mini booking-extend">
            <div class="contador">{{route.childsCount}}</div>
        </div>

        <!-- ID DE LA RUTA -->
        <div class="routeId only-hardman">{{route.routeId}}</div>
    </div>
</shared-generalstatus-container>